import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { FlashSalesDeal } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { calculateReduction } from '@backmarket/utils/math/calculateReduction'

export function applyFlashSalesDiscount(
  price: Price,
  discount: FlashSalesDeal['discount'],
) {
  const flashSalesDiscount = {
    amount: discount.amount.toString(),
    currency: discount.currency,
  }

  return calculateReduction(price, flashSalesDiscount) ?? price
}
